<template lang="pug">
  v-dialog(v-model='dialog' width='1000')
    template(v-slot:activator='{ on }')
      v-btn(color='primary' v-on='on' @click='recorrido()' :disabled='(state.seleccionar.length==0)')
        v-icon fas fa-money-bill-wave-alt
    v-card
      v-form(autocomplete=false v-model='valid')
        v-toolbar(dark color='primary')
            h2 Pagar cuenta
            v-spacer
            v-btn(icon dark @click='dialog=false; limpiar()')
                v-icon fas fa-times
        v-container(grid-list-md)
            v-row.pa-5
                v-col.xs6.pa-1
                    v-text-field(label='Monto a pagar' v-model='(state.monto==0) ? "No ha seleccionado ninguna cuenta a pagar" : state.monto' outlined disabled)
                v-col.xs6.pa-1
                    v-autocomplete(:rules='[rules.required]' v-model='state.debe' label='Seleccione cuenta con qué pagar' :items='registro_partidas_contables' :item-text='item=>item.codigo+" / "+item.descripcion' :item-value='item=>item.codigo')
            v-spacer
            v-row
                v-col.xs5.pa-1
                v-spacer
                    v-btn(color='primary' @click='(valid) ? pagar({conjunto_partidas: state.reglas_seleccionadas, partida_pago: state.debe}) : null; dialog=false' :disabled='(valid && state.monto!=0) ? false : true' v-html='"Pagar"') 

</template>
<script>
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex'
import { getPeriod } from '@/Helper.js'
export default {
    data: ()=>({
        valid: true,
        dialog: false,
    }),
    methods: {
        ...mapActions({
            pagar: 'Cuentas_por_pagar/pagar',
            recorrido: 'Cuentas_por_pagar/recorrido_arreglo',
            get: 'Partidas_Contables/get',
            limpiar: 'Cuentas_por_pagar/limpiar'
        }) 
    },
    props:{
        objeto: Object,
    },
    computed: {
        ...mapState({
            rules: state=>state.Helpers.rules,
            state: state=>state.Cuentas_por_pagar,
            cuenta: state=>state.Cuentas_por_pagar.cuenta_por_pagar
        }),
        ...mapGetters({
            registro_partidas_contables: 'Partidas_Contables/record',
        }),
    }
}
</script>

